
import { decodeJwtToken } from "./tokenService";

const checkPermissions:any = ( requiredRoles = []) => {
  try {
    if(requiredRoles.length==0){
        return true;
    }
    const decodedToken:any = decodeJwtToken();
    const { Permission = [] } = decodedToken;
    // Check if user has any of the required roles
    const hasPermission = requiredRoles.some(role => Permission.includes(role));
    if (!hasPermission) {
      throw new Error("Insufficient permissions");
    }

    return true;
  } catch (error:any) {
    console.error("Permission check failed:", error.message);
    return false;
  }
};

export default checkPermissions;
